
import styled from 'styled-components';

export const StyledlistItems = styled.button`
  .listItemsWidth {
    width: 200px;
  }
`;